import { render } from "./SkillscardDetailsPage.vue?vue&type=template&id=519de370&scoped=true&ts=true"
import script from "./SkillscardDetailsPage.vue?vue&type=script&lang=ts"
export * from "./SkillscardDetailsPage.vue?vue&type=script&lang=ts"

import "./SkillscardDetailsPage.vue?vue&type=style&index=0&id=519de370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519de370"]])

export default __exports__